import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Select,
  MenuItem,
  FormControl,
  Box,
  Typography,
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
    // Guardar la preferencia en localStorage
    localStorage.setItem('language', selectedLanguage);
  };

  const currentLanguage = languages.find((lang) => lang.code === (i18n.language || 'en')) || languages[0];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <LanguageIcon sx={{ color: 'black', fontSize: '1.2rem' }} />
      <FormControl
        variant="outlined"
        size="small"
        sx={{
          minWidth: 120,
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.23)',
            },
            '&:hover fieldset': {
              borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'black',
            },
          },
        }}
      >
        <Select
          value={i18n.language || 'en'}
          onChange={handleLanguageChange}
          renderValue={(value) => {
            const selectedLang = languages.find((lang) => lang.code === value) || languages[0];
            return (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>{selectedLang.flag}</span>
                <Typography sx={{ fontSize: '0.9rem' }}>{selectedLang.name}</Typography>
              </Box>
            );
          }}
          sx={{
            color: 'black',
            fontSize: '0.9rem',
            '& .MuiSelect-select': {
              padding: '6px 14px',
            },
            '& .MuiSvgIcon-root': {
              color: 'black',
            },
          }}
        >
          {languages.map((lang) => (
            <MenuItem key={lang.code} value={lang.code}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <span>{lang.flag}</span>
                <Typography sx={{ fontSize: '0.9rem' }}>{lang.name}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageSelector;

